export { default } from './ProductCardParamsBasicShort';
